import React from 'react'
import PropTypes from 'prop-types'

import { useToggle } from '../utils/hooks'
import Button from '../Button'

const AlertBox = ({
  icon,
  title,
  message,
  buttonOneFunc,
  buttonOneText,
  buttonTwoFunc,
  buttonTwoText,
  link,
  linkText,
  onDismiss,
  variant = 'primary',
  dismissible = true
}) => {
  const [alertBox, toggleAlertBox] = useToggle(true)

  const validFunctionOne = typeof buttonOneFunc === 'function'
  const validFunctionTwo = typeof buttonTwoFunc === 'function'
  const validDismissFunction = typeof onDismiss === 'function'

  return (
    alertBox &&
    <div className={`d-flex alert alert-${variant}`} role='alert'>
      <div className='w-100'>
        {title &&
          <div className='d-flex align-items-center alert-heading'>
            {icon && <h4 className={`fas fa-${icon} me-3`} aria-hidden='true' />}
            {title && <h5>{title}</h5>}
          </div>
        }
        {message && <div>{message}</div>}
        {(buttonOneText || buttonTwoText || linkText) &&
          <div className='d-flex align-items-center mt-3'>
            {buttonOneText && <Button variant={variant} className='me-2' onClick={() => {
              validFunctionOne && buttonOneFunc()
              toggleAlertBox()
            }}>
              {buttonOneText}
            </Button>}

            {buttonTwoText && <Button outline variant={variant} className='bg-white me-2' onClick={() => {
              validFunctionTwo && buttonTwoFunc()
              toggleAlertBox()
            }}>
              {buttonTwoText}
            </Button>}

            {linkText && <a className={`link-${variant} text-decoration-none`} href={link} target='_blank' rel='noopener noreferrer'>{linkText}</a>}
          </div>
        }
      </div>
      {dismissible &&
        <div>
          <Button ghost variant={variant} size='sm' ariaLabel='Close' onClick={() => {
            validDismissFunction && onDismiss()
            toggleAlertBox(false)
          }}>
            <span className='fas fa-times fs-6' aria-hidden='true' />
          </Button>
        </div>
      }
    </div>
  )
}

AlertBox.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  message: PropTypes.string,
  buttonOneFunc: PropTypes.func,
  buttonOneText: PropTypes.string,
  buttonTwoFunc: PropTypes.func,
  buttonTwoText: PropTypes.string,
  link: PropTypes.string,
  linkText: PropTypes.string,
  onDismiss: PropTypes.func,
  variant: PropTypes.any,
  dismissible: PropTypes.bool
}

export default AlertBox
